import { render, staticRenderFns } from "./approvers.vue?vue&type=template&id=3fcbe9a7&scoped=true&"
import script from "./approvers.vue?vue&type=script&lang=js&"
export * from "./approvers.vue?vue&type=script&lang=js&"
import style0 from "./approvers.vue?vue&type=style&index=0&id=3fcbe9a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcbe9a7",
  null
  
)

export default component.exports